import * as types from "./actionTypes";
import { LYRIC_SIZES, isDarkTheme } from "../lib/preferences";

export const setPreferences = (changes) => ({ type: types.PREFERENCES_SET, ...changes });

export const setTheme = (theme) => setPreferences({ theme });

/** The "dim room" switch: on is the dark theme, off the light one (no more following the system). */
export const setDimRoom = (on) => setTheme(on ? "dark" : "light");

export const toggleDimRoom = () => (dispatch, getState) => dispatch(setDimRoom(!isDarkTheme(getState().preferences.theme)));

export const setHighContrast = (highContrast) => setPreferences({ highContrast });

export const setShowChords = (showChords) => setPreferences({ showChords });

export const setKeepAwake = (keepAwake) => setPreferences({ keepAwake });

export const setKeepFavoritesOffline = (keepFavoritesOffline) => setPreferences({ keepFavoritesOffline });

export const setLyricSize = (lyricSize) => setPreferences({ lyricSize });

/** Makes the lyrics one step bigger (+1) or smaller (-1). */
export const stepLyricSize = (direction) => (dispatch, getState) =>
  dispatch(setLyricSize(Math.min(LYRIC_SIZES.length - 1, Math.max(0, getState().preferences.lyricSize + direction))));

/** Remembers how this device transposes a song (0 forgets it). */
export const setSongKey = (songId, semitones) => ({ type: types.PREFERENCES_SET_SONG_KEY, songId, semitones });
